import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AvatarCreateState, avatarCreateKey } from './create.state';

/**
 * Select avatar create feature state.
 */
export const selectAvatarCreateState =
  createFeatureSelector<AvatarCreateState>(avatarCreateKey);

/**
 * Select current step.
 */
export const selectAvatarCreateCurrentStep = createSelector(
  selectAvatarCreateState,
  (state) => state.currentStep
);

/**
 * Select selected image.
 */
export const selectAvatarCreateSelectedImage = createSelector(
  selectAvatarCreateState,
  (state) => state.selectedImage
);

/**
 * Select avatar ID.
 */
export const selectAvatarCreateAvatarId = createSelector(
  selectAvatarCreateState,
  (state) => state.avatarId
);

/**
 * Select status.
 */
export const selectAvatarCreateStatus = createSelector(
  selectAvatarCreateState,
  (state) => state.status
);

/**
 * Select validation error.
 */
export const selectAvatarCreateValidationError = createSelector(
  selectAvatarCreateState,
  (state) => state.validationError
);

/**
 * Select loading state.
 */
export const selectAvatarCreateLoading = createSelector(
  selectAvatarCreateState,
  (state) => state.loading
);

/**
 * Select error.
 */
export const selectAvatarCreateError = createSelector(
  selectAvatarCreateState,
  (state) => state.error
);

/**
 * Select polling attempts.
 */
export const selectAvatarCreatePollingAttempts = createSelector(
  selectAvatarCreateState,
  (state) => state.pollingAttempts
);

/**
 * Select max polling attempts.
 */
export const selectAvatarCreateMaxPollingAttempts = createSelector(
  selectAvatarCreateState,
  (state) => state.maxPollingAttempts
);

/**
 * Select polling start time.
 */
export const selectAvatarCreatePollingStartTime = createSelector(
  selectAvatarCreateState,
  (state) => state.pollingStartTime
);

/**
 * Select max polling duration.
 */
export const selectAvatarCreateMaxPollingDuration = createSelector(
  selectAvatarCreateState,
  (state) => state.maxPollingDuration
);

/**
 * Select if currently polling.
 */
export const selectAvatarCreateIsPolling = createSelector(
  selectAvatarCreateLoading,
  (loading) => loading.polling
);

/**
 * Select if currently uploading.
 */
export const selectAvatarCreateIsUploading = createSelector(
  selectAvatarCreateLoading,
  (loading) => loading.uploading
);
